import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage, getStringWithoutHyphens } from "helpers";
import { merchantInfoService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type TaxIdFieldValuesProps = {
	taxId: string;
};

type TaxIdFieldMutationProps = {
	id: number;
	values: TaxIdFieldValuesProps;
	onSuccessHandler?: Function;
};

const useTaxIdFieldMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id, values }: TaxIdFieldMutationProps) => {
			const normalizedTaxId = getStringWithoutHyphens(values?.taxId);
			return merchantInfoService.editTaxIdField(id, normalizedTaxId);
		},
		{
			onSuccess(data, { onSuccessHandler }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Field Federal Tax ID has been updated successfully",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useTaxIdFieldMutation;
